var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tableOptions)?_c('x-default-data-table',{attrs:{"x-options":_vm.tableOptions,"x-context":_vm.self},scopedSlots:_vm._u([{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('div',{staticClass:"py-4"},[_c('vnd-transaction-details-table',{attrs:{"paymentVndTransactionId":item._id}})],1)])]}}],null,false,134552405)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }